/*@ngInject*/
const RepeatingRowsDirective = function ($rootScope, formComponentRenderingUtil, formViewerConstant, rowRepeaterUtil, rowRepeaterRowListComparisonResultConstant) {

    let linkFunction = function ($scope, $elm) {

        const rowRepeaterContainer = $($elm);

        let renderedRows;

        function createRepeatingRow(row) {
            formComponentRenderingUtil.createRepeatingRow(row, rowRepeaterContainer, $scope.hideRowNumbers, $scope.configurable);
            _.map(row.fieldStructureList, function (fieldStructure) {
                if ($scope.configurable) {
                    formComponentRenderingUtil.createConfigurableComponent(fieldStructure, row.viewContainer, true);
                } else {
                    formComponentRenderingUtil.createComponentByType(fieldStructure, row.viewContainer, true);
                }
            });
        }

        $scope.$watch('visibleRows', function () {

            let reRender = false;
            let rowRenderingHappened = false;

            if (_.isEmpty(renderedRows)) {
                renderedRows = $scope.visibleRows;
                reRender = true;
            }

            if (!reRender) {
                const rowRepeaterRowListComparisonResult = rowRepeaterUtil.compareRowLists($scope.visibleRows, renderedRows);

                switch(rowRepeaterRowListComparisonResult) {
                    // If we have added a single new row, add that new row without having to re-render the entire row repeater
                    case rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED:
                        createRepeatingRow($scope.visibleRows[$scope.visibleRows.length - 1]);
                        rowRenderingHappened = true;
                        break;

                    // More than one row was added, rows were removed or the number of rows is unchanged but the contents changed, re-render the entire row repeater.
                    case rowRepeaterRowListComparisonResultConstant.MORE_THAN_ONE_ROW_ADDED:
                    case rowRepeaterRowListComparisonResultConstant.ROWS_REMOVED:
                    case rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED:
                        reRender = true;
                        break;

                    case rowRepeaterRowListComparisonResultConstant.EQUAL:
                    default:
                        break;
                }
            }

            renderedRows = $scope.visibleRows;
            if (reRender) {
                const scopeList = $(`.${$scope.rowRepeaterIden} .repeatingRowContainer .ng-scope`);
                const isolateScopeList = $(`.${$scope.rowRepeaterIden} .repeatingRowContainer .ng-isolate-scope`);

                formComponentRenderingUtil.manuallyDestroyDomScope(scopeList, isolateScopeList);
                rowRepeaterContainer.empty();

                _.each($scope.visibleRows, function (row) {
                    createRepeatingRow(row);
                });

                if (!_.isNil($scope.visibleRows) && !_.isEmpty($scope.visibleRows)) {
                    rowRenderingHappened = true;
                }
            }

            if (rowRenderingHappened) {
                $rootScope.$broadcast(formViewerConstant.event.ROW_RENDERING_COMPLETE);
            }
        });
    };

    return {
        restrict: 'E',
        replace: false,
        link: linkFunction,
        scope: {
            rowRepeaterIden: '<',
            visibleRows: '<',
            hideRowNumbers: '<',
            configurable: '<'
        }
    };
};

angular.module('umFormViewer')
    .directive('uiRepeatingRows', RepeatingRowsDirective);
